"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AnaccVariableComponentDto {
    constructor(init) {
        Object.assign(this, init);
    }
}
exports.AnaccVariableComponentDto = AnaccVariableComponentDto;
